import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { FaQuoteLeft } from 'react-icons/fa';
import { fetchTestimonialsApi, fetchCastingDirectorsApi } from '../services/api';
import './TestimonialAndDirectors.css';
import { useNavigate } from 'react-router-dom';

const TestimonialAndDirectors = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [castingDirectors, setCastingDirectors] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const tRes = await fetchTestimonialsApi();
      const cRes = await fetchCastingDirectorsApi();
      setTestimonials(tRes.data.data || []);
      setCastingDirectors(cRes.data.data || []);
    } catch (err) { console.error(err); }
  };


  const testimonialSettings = {
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  arrows: false,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const directorSettings = {
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  arrows: false,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

  // Helper for images
  const getImgUrl = (item) => {
    const url = item.user?.profile_image_url || item.profile_image_url;
    if (url?.startsWith("http")) return url;
    if (url) return `${process.env.REACT_APP_API_URL.replace("/api", "")}/uploads/${url}`;
    return null; // Null return karenge agar image nahi hai, toh CSS ya UI fallback chalega
  };

  return (
    <section className="testimonial-wrapper">
      {/* <div className="container"> */}
      <div className="container-fluid testimonial-container">
        
        <h2 className="testimonial-heading">Success <span>Stories</span></h2>
        {/* <div className="row g-4 mb-5"> */}
        <Slider {...testimonialSettings}>
          {testimonials.slice(0, 3).map((item) => (
            // <div key={item.id} className="col-12 col-md-4">
            <div key={item.id} className="slider-padding">
              <div
  className="testimonial-box"
  onClick={(e) => e.preventDefault()}
>
  <div className="testimonial-left">
    <img
      src={
        getImgUrl(item) ||
        `https://ui-avatars.com/api/?name=${item.name || "User"}&background=d00000&color=fff`
      }
      alt={item.name}
      className="testimonial-avatar"
    />

    <h5 className="testimonial-name">
      {item.name}
    </h5>

    <span className="testimonial-role">
      {item.talent_name || "Actor"}
    </span>
  </div>

  <div className="testimonial-right">
    {/* <FaQuoteLeft className="quote-icon" /> */}

    {/* <p className="testimonial-text">
      {item.description && item.description.length > 180
        ? item.description
        : "Rock My Audition gave me the platform I needed. From my first audition to my first break everything was smooth and professional."}
    </p> */}
    <p className="testimonial-text">
  {item.description?.length > 180
    ? `${item.description.substring(0, 180)}...`
    : item.description}
</p>
  </div>
</div>
            </div>
          ))}
        </Slider>

        <h2 className="testimonial-heading casting-heading">Popular <span>Casting Directors</span></h2>
        {/* <div className="row g-4"> */}
        <Slider {...directorSettings}>
          {castingDirectors.slice(0, 4).map((director) => (
            // <div key={director.id} className="col-12 col-sm-6 col-md-3">
            <div key={director.id} className="slider-padding">
              <div className="director-box" onClick={() => navigate(`/casting-director-profile/${director.joget_user_id}`)}>
                <img 
                  src={getImgUrl(director) || `https://ui-avatars.com/api/?name=${director.full_name || "CD"}&background=d00000&color=fff`} 
                  alt={director.full_name} 
                  className="director-avatar" 
                />
                <h5 className="director-name">{director.full_name}</h5>
                <p className="director-desc">{director.about_agency || "Professional Casting Director"}</p>
              </div>
            </div>
          ))}
        </Slider>

      </div>
    </section>
  );
};

export default TestimonialAndDirectors;